import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { apiGateway, useEnrolmentStatusContext } from "../context";
import { AxiosError } from "axios";
import { ErrorType } from "@screens/FeaAuth/hooks/onQuestionChallengeError";

export type CreateClaveUnicaURL = {
  url: string | null;
  message: string | null;
};

type MutationProps = {
  requestId?: string;
};

export const useGetClaveUnicaUrl = () => {
  // Show loading spinner depending on the state of the esign flow
  // but adding a delay to consider the redirection to the 'clave unica' login
  const [isGettingClaveUnicaUrl, setIsGettingClaveUnicaUrl] = useState(false);
  const { getEnrolmentStatus, setCurrentStep, setCurrentStepStatus } =
    useEnrolmentStatusContext();
  return {
    getClaveUnicaUrlMutation: useMutation({
      mutationFn: (variables: MutationProps) =>
        apiGateway<CreateClaveUnicaURL>({
          method: "post",
          url: "/enrolment/clave-unica",
          data: {
            requestId: variables?.requestId ?? null,
          },
        }),
      onMutate: () => {
        setIsGettingClaveUnicaUrl(true);
      },
      onSuccess: async (data) => {
        if (data.message === "Validation is still valid") {
          await getEnrolmentStatus();
          return;
        }
        if (data.url) {
          window.location.href = data.url;
        }
      },
      onError: async (error: AxiosError<ErrorType>) => {
        console.error("Error getting clave unica url: ", error);
        const errorData = error.response?.data;
        const nextStep = errorData?.nextStep;
        const nextStepStatus = errorData?.nextStepStatus;
        if (nextStep && nextStepStatus) {
          setCurrentStep(nextStep);
          setCurrentStepStatus(nextStepStatus);
        } else {
          await getEnrolmentStatus();
        }
      },
      onSettled: () => {
        const timeoutId = setTimeout(() => {
          setIsGettingClaveUnicaUrl(false);
        }, 5000);
        return () => clearTimeout(timeoutId);
      },
    }),
    isGettingClaveUnicaUrl,
  };
};
